import isNil from 'lodash/isNil';

import { RadioOptionType } from '../Radio';

const defineInitialValue = (
  initial: string | undefined,
  defaultValue: string | undefined,
  value: string | undefined,
  checkedOption: RadioOptionType | undefined,
) => {
  if (!isNil(value)) return value;
  if (!isNil(checkedOption)) return checkedOption && checkedOption.value;
  if (!isNil(defaultValue)) return defaultValue;
  if (!isNil(initial)) return initial;
  return null;
};

export default defineInitialValue;
